'use strict';

const Bullet = require('../entities/bullet');

class BulletPool {
  constructor(capacity) {
    this.capacity = capacity || 100;
    this.limit = this.capacity;
    this.items = [];
    for (let i = 0; i < this.capacity; i += 1) this.items.push(new Bullet());
  }

  setLimit(limit) {
    this.limit = Math.max(1, Math.min(this.capacity, Math.floor(limit)));
  }

  activeCount() {
    let count = 0;
    for (let i = 0; i < this.items.length; i += 1) {
      if (this.items[i].active) count += 1;
    }
    return count;
  }

  spawn(options) {
    if (this.activeCount() >= this.limit) return null;
    for (let i = 0; i < this.items.length; i += 1) {
      if (!this.items[i].active) return this.items[i].reset(options);
    }
    return null;
  }

  update(dt, bounds, target) {
    for (let i = 0; i < this.items.length; i += 1) {
      this.items[i].update(dt, bounds, target);
    }
  }

  draw(ctx) {
    for (let i = 0; i < this.items.length; i += 1) this.items[i].draw(ctx);
  }

  getActive() {
    const active = [];
    for (let i = 0; i < this.items.length; i += 1) {
      if (this.items[i].active) active.push(this.items[i]);
    }
    return active;
  }

  clear() {
    for (let i = 0; i < this.items.length; i += 1) this.items[i].active = false;
  }
}

module.exports = BulletPool;
